import { Component, OnInit, OnDestroy } from '@angular/core';
import { ManageService } from '../../../services/manage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CSPPerpetualItemsViewModel, CspAzureRilist, CSPPerpetual_AzureRISubscriptionViewModel, DickerSelectListItem, CspAzureRicatalog, GetProductPricingV2, CSPDetailsItemViewModel } from '../../../models/csp.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-add-azure-ri',
  templateUrl: './add-azure-ri.component.html',
  styleUrls: ['./add-azure-ri.component.css']
})
export class AddAzureRiComponent implements OnInit, OnDestroy {

  title: string= "Select Azure Catalogue";
  azureRIItemsPendingList: CSPPerpetualItemsViewModel[] = [];
  azureRiList: CspAzureRilist[];
  azureRiListFilter: CspAzureRilist[];
  azureRiMpnIdSelect: string;
  azureRiUsageSubscriptionList: CSPPerpetual_AzureRISubscriptionViewModel;
  cspItemList: DickerSelectListItem[];
  azureRiCatalog: CspAzureRicatalog[];
  azureRiCatalogFilter: CspAzureRicatalog[];
  priceList: GetProductPricingV2[];
  loadContent: boolean = false;
  tenantId: string;
  mpnList: string[];
  setFullWindow: boolean = false;
  searchCatalog: string;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private manageService: ManageService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.loadContent = false;
    this.activatedRoute.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(url => {
      $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });
    
    this.activatedRoute.parent.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(url => {
      this.tenantId = url[1].path;
      // debugger;
      this.manageService.GetCspAzureRicatalog().subscribe((res: CspAzureRicatalog[]) => {
        this.azureRiCatalog = res;
        this.azureRiCatalogFilter = this.azureRiCatalog;
        this.loadContent = true;
      },
        (error: any) => {
          console.info(error);
        });
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });
  }

  filterAzureRiCatalogs(): void{
    this.azureRiCatalogFilter = this.azureRiCatalog.filter(catalog => catalog.title.toLowerCase().includes(this.searchCatalog.toLowerCase()) || catalog.productId.toLowerCase().includes(this.searchCatalog.toLowerCase()))
  }

  selectAzureRiCatalogue(catalogue: CspAzureRicatalog): void{
    this.router.navigate(["SelectAzureRi/"+catalogue.id], { relativeTo: this.activatedRoute });
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    console.log('close event');
    this.manageService.monitorSelectedTabIndex(3);
    this.manageService.backToTenentPage(this.tenantId);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
